import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

import DateSelector from "@cayuse/shared-react.components.date-selector";

import Table from "components/Table";
import { shellSelectors, tenantSelectors } from "store/selectors";

import styles from "./styles.css";


export const FASetupRow = ({ editable, period, onChange }) => {
	const { dateFormat } = useSelector(tenantSelectors.tenant);
	const locale = useSelector(shellSelectors.locale);

	const onStartDateChange = startDate => onChange({ ...period, startDate });
	const onEndDateChange = endDate => onChange({ ...period, endDate });

	const onRateForPeriodChange = rateForPeriod => onChange({ ...period, rateForPeriod });

	const startDateInputValue = useMemo(
		() => period?.startDate ? moment(period.startDate).toDate() : null,
		[ period.startDate ],
	);
	const endDateInputValue = useMemo(
		() => period?.endDate ? moment(period.endDate).toDate() : null,
		[ period.endDate ],
	);

	const formattedStartDate = useMemo(
		() => period.startDate ? moment(period.startDate).format(dateFormat) : dateFormat,
		[ dateFormat, period.startDate ],
	);
	const formattedEndDate = useMemo(
		() => period.endDate ? moment(period.endDate).format(dateFormat) : dateFormat,
		[ dateFormat, period.endDate ],
	);

	return (
		<Table.Row>
			<Table.Cell>{period.periodNumber}</Table.Cell>
			<Table.Cell>
				{editable
					? (
						<div className="ui form">
							<DateSelector
								className={styles.dropdown}
								onChange={onStartDateChange}
								selectedDate={startDateInputValue}
								placeholderText={dateFormat}
								locale={locale}
							/>
						</div>
					)
					: formattedStartDate
				}
			</Table.Cell>
			<Table.Cell>
				{editable
					? (
						<div className="ui form">
							<DateSelector
								className={styles.dropdown}
								onChange={onEndDateChange}
								selectedDate={endDateInputValue}
								placeholderText={dateFormat}
								locale={locale}
							/>
						</div>
					)
					: formattedEndDate
				}
			</Table.Cell>
			<Table.Cell>
				{editable
					? (
						<div className={styles.faRateInput}>
							<input
								type="number"
								defaultValue={period.rateForPeriod}
								onChange={event => onRateForPeriodChange(event?.target?.value)}
							/>
						</div>
					)
					: period.rateForPeriod
				}
			</Table.Cell>
		</Table.Row>
	);
};

